import { customDateFormatWithTime, textFormatter } from "components/Common/formatter";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import editIcon from "assets/images/svg/Edit.svg";
import React from "react";
import ButtonGroupContainer from "components/Common/buttons/ButtonGroupContainer";
import deleteIcon from "assets/images/svg/Delete.svg";

const ALLOWED_EDIT = ["Draft", "Preparing", "Prepared"];
const ALLOWED_REMOVE = ["Draft", "Preparing", "Prepared", "Loaded"];

export const loadingBaysListColumns = (editLb, removeLb) => [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Created By",
    dataIndex: "createdBy",
  },
  {
    title: "Location",
    dataIndex: "location",
  },
  {
    title: "Created at",
    dataIndex: "createdAt",
    render: cellContent => textFormatter(customDateFormatWithTime(cellContent)),
  },
  {
    title: "Asset Type",
    dataIndex: "assetsGroup",
  },
  {
    title: "Condition",
    dataIndex: "assetsCondition",
  },
  {
    title: "Qty",
    dataIndex: "quantity",
  },
  {
    title: "",
    dataIndex: "tripNumber",
    render: (tripNumber, row) => (
      <ButtonGroupContainer hasMobileView>
        <ButtonGroup
          disabled={!ALLOWED_EDIT.includes(row.status)}
          handleClick={() => {
            editLb(row.id);
          }}
          tooltipTitle="Edit"
          icon={editIcon}
        />
        <ButtonGroup
          disabled={!ALLOWED_REMOVE.includes(row.status)}
          handleClick={() => {
            removeLb(row);
          }}
          tooltipTitle="Remove"
          icon={deleteIcon}
        />
      </ButtonGroupContainer>
    ),
  },
];
